<template>
  <div 
    class="remote-scroller-bar" 
    ref="bar"
    @mousedown="startGrab"
    @mouseup="endGrab"
    v-show="shown">
      <div 
        class="remote-scroller-control" 
        ref="control"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      target_el: null,
      position: 0,
      shown: true,

      grabbing: false,
      
      max_absolute_scroll: 0,
      max_relative_scroll: 0
    }
  },
  watch: {
    position() {
      this.$refs.control.style.left = `${this.position}px`;
    }
  },
  methods: {
    startGrab() {
      this.grabbing = true;
    },
    endGrab() {
      this.grabbing = false;
    },
    onMouseMove(ev) {
      if (!this.grabbing) return;

      if (!this.shown) return;

      const delta = ev.movementX;

      if (!delta || delta == 0) return;

      ev.preventDefault();
      ev.stopPropagation();

      // this.position += delta;

      // if (this.position < 0) this.position = 0;
      // if (this.position > this.max_relative_scroll) this.position = this.max_relative_scroll;

      this.target_el.scrollLeft += delta * 2.5;
    },  
    onGlobalMouseUp() {
      if (this.grabbing) this.grabbing = false;
    },
    bindListeners() {
      this.target_el.addEventListener('scroll', this.onWindowScroll);
      
      window.addEventListener('mousemove', this.onMouseMove);

      window.addEventListener('mouseup', this.onGlobalMouseUp);

      window.addEventListener('resize', this.updateWidth);

      this.target_el.addEventListener('resize', this.updateWidth);
    },
    unbindListeners() {
      this.target_el.removeEventListener('scroll', this.onWindowScroll);
      
      window.removeEventListener('mousemove', this.onMouseMove);

      window.removeEventListener('mouseup', this.onGlobalMouseUp);

      window.removeEventListener('resize', this.updateWidth);

      this.target_el.removeEventListener('resize', this.updateWidth);
    },
    onWindowScroll() {
      const bar_el = this.$refs.bar;
      const control_el = this.$refs.control;

      //max_abs_scroll - max_rel_pos
      //current_scroll - rel_pos

      const new_control_pos = this.target_el.scrollLeft * this.max_relative_scroll / this.max_absolute_scroll;

      this.position = new_control_pos;
    },
    updateWidth() {
      const bar_el = this.$refs.bar;
      const control_el = this.$refs.control;

      const cafe_scroll_block = document.getElementById('cafeScrollBlock');
      const menu_scroll_block = document.getElementById('menuScrollContainer');

      if (cafe_scroll_block) {
        this.target_el = cafe_scroll_block;
      } else if (menu_scroll_block) {
        this.target_el = menu_scroll_block;
      } else {
        const el = document.getElementsByClassName('horizontal-scroll')[0];

        this.target_el = el;

        if (!el) {
          this.shown = false;
          return;
        }
      }

      if (Math.abs(this.target_el.scrollWidth - this.target_el.offsetWidth) <= 1) {
        this.shown = false;
        return;
      } else {
        this.shown = true;
      }

      //window scroll - bar width
      //screen size - control width

      const control_width = this.target_el.offsetWidth * bar_el.offsetWidth / this.target_el.scrollWidth;

      console.log(control_width);

      control_el.style.width = `${control_width}px`;  

      this.max_absolute_scroll = Math.abs(
        this.target_el.scrollWidth - this.target_el.offsetWidth
      );

      this.max_relative_scroll = bar_el.offsetWidth - control_el.offsetWidth;
    }
  },
  mounted() {
    this.updateWidth();
    this.bindListeners();
  },
  beforeDestroy() {
    this.unbindListeners();
  }
}
</script>

<style>
.remote-scroller-bar {
  position: fixed;
  right: 2.3vh;
  bottom: 2.3vh;
  
  width: 50vh;
  height: 2vh;

  border-radius: 1vh;

  background: #a4a3a1;
}

.remote-scroller-control {
  position: absolute;

  height: 2.3vh;
  width: 5vh;

  border-radius: 1vh;
  background: #1d1d1b;
  z-index: 10;
  top: -0.1vh;
}

.remote-scroller-control:hover {
  transform: scale(1.1);
  cursor: grabbing;
}
</style>